<div class="app-container">
  <app-toolbar />
  <div class="router-container">
    <router-outlet></router-outlet>
  </div>
</div>
